import { Component, Input } from '@angular/core';

import { CallbackResult, CallbackResultStatus, trackByIdx } from '../../../../../../../../utils';
import { CustomCustomerField } from '../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomCustomerFieldType } from '../../../../../../../../models/organization-config-enums';


@Component({
  selector: 'app-edit-custom-customer-field-modal',
  templateUrl: './edit-custom-customer-field-modal.component.html',
  styleUrls: ['./edit-custom-customer-field-modal.component.css']
})
export class EditCustomCustomerFieldModalComponent {
  @Input() field: CustomCustomerField;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  public CustomCustomerFieldType = CustomCustomerFieldType;
  public trackByIdx = trackByIdx;

  constructor(
    public activeModal: NgbActiveModal,
    private orgConfigService: OrganizationConfigService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.orgConfigService
      .updateCustomCustomerField(this.field)
      .then(updatedField => {
        let successText = 'Field updated successfully.';
        if (updatedField.name && updatedField.name.length > 0) {
          successText = updatedField.name + ' updated successfully.';
        }
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to update this custom field.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
